export default "__VITE_ASSET__CrJTZ5oL__"